import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost, errorMessage, qk } from "@/shared/api";

/**
 * Подтверждение и отклонение заявки на пополнение.
 *
 * Инвалидируется не только список заявок: подтверждение двигает баланс
 * пользователя и попадает в журнал, поэтому карточка пользователя, сводка и
 * журнал обязаны перечитаться — иначе оператор увидит там состояние до
 * собственного действия.
 */
export function useProcessDeposit() {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  const invalidate = (userId: number) => {
    void queryClient.invalidateQueries({ queryKey: ["deposits"] });
    void queryClient.invalidateQueries({ queryKey: qk.dashboard() });
    void queryClient.invalidateQueries({ queryKey: ["audit"] });
    void queryClient.invalidateQueries({ queryKey: qk.user(userId) });
    void queryClient.invalidateQueries({ queryKey: ["users"] });
  };

  const approve = useMutation({
    mutationFn: (input: { id: number; userId: number; comment?: string }) =>
      apiPost("/api/v1/admin/deposits/{deposit_id}/approve", {
        params: { deposit_id: input.id },
        body: input.comment ? { comment: input.comment } : {},
      }),
    onSuccess: (_, input) => {
      invalidate(input.userId);
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });

  const reject = useMutation({
    mutationFn: (input: { id: number; userId: number; comment: string }) =>
      apiPost("/api/v1/admin/deposits/{deposit_id}/reject", {
        params: { deposit_id: input.id },
        body: { comment: input.comment },
      }),
    onSuccess: (_, input) => {
      invalidate(input.userId);
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });

  return { approve, reject };
}
